import React from 'react';
import IconButton  from '@material-ui/core/IconButton';
import Chip  from '@material-ui/core/Chip';
import Tooltip  from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone'
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import {isEmpty} from 'lodash'
import {useSelector,useDispatch} from 'react-redux'
import { updateAnpassadName,DeleteAnpassadName } from 'actions'
//Notyfile Table
import NotyfileTable from "../../../NotyfileTable";
import NotyfileTableHeader from "../../../NotyfileTable/tableHeader";
import RapportName from './Inputs/RapportName.js'
import DeleteItemPopUp from './DeleteItemPopUp'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });
function GetChipsFromSaved(props) {
    const dispatch = useDispatch()
    const classes = useStyles();
    const Userlista = useSelector(state => state.accountsData.Userlista)
    const ProspektFasList = useSelector(state => state.accountsData.ProspektFaslist)
    const Utokning = useSelector(state => state.accountsData.Utokning)
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const userid = useSelector(state => state.auth.authUser.user_id)
    let YesOption = props.intl.formatMessage({ id: 'Option.Yes' });
    const AllLabel = props.intl.formatMessage({ id: 'All' });
    const [page,setPage] = React.useState(1)
    const [searchWord,setsearchWord] = React.useState("")
    const [DelItem,setDelItem] = React.useState({})
    const [Data,setData]=React.useState([])
    const [columns] = React.useState([
        { width: '150px', title:<IntlMessages id="Table.Name"/>, field: 'namn', cellStyle: { padding:'2px 16px', borderTop: '4px solid #FFF', backgroundColor: '#FFF', borderBottom: '4px solid #FFF', fontSize:15 } },
        { title:<IntlMessages id="Filter"/>, field: 'owner', headerStyle: { textAlign: 'left' },   cellStyle: { padding:'4px', textAlign:'left', backgroundColor: '#FFF', borderLeft: '4px solid #FFF', borderTop: '4px solid #FFF', borderBottom: '4px solid #FFF', } },
        { width: '100px', title: <IntlMessages id="Table.Date"/>, field: 'fil', headerStyle: { textAlign: 'center' },   cellStyle: { padding:'5px', textAlign:'center', backgroundColor: '#FFF', borderLeft: '4px solid #FFF', borderTop: '4px solid #FFF', borderBottom: '4px solid #FFF', } },
        { width: '50px', title: '', field: 'taBort', cellStyle: { padding:'5px', textAlign:'center', backgroundColor: '#FFF', borderLeft: '4px solid #FFF', borderTop: '4px solid #FFF', borderBottom: '4px solid #FFF', } },
        { width: '50px', title: '', field: 'Edit', cellStyle: { padding:'5px', textAlign:'center', backgroundColor: '#FFF', borderLeft: '4px solid #FFF', borderTop: '4px solid #FFF', borderBottom: '4px solid #FFF', } },
      ])
    React.useEffect(()=>{
        createData()
    },[props.SavedAnRapport,searchWord])
    const createData=()=>{
        let data = isEmpty(props.SavedAnRapport) ? [] : props.SavedAnRapport
        .filter(item=>{return item.RapportName.toLowerCase().includes(searchWord.toLowerCase())})
        .map((n) => {
            return [
                {
                    label: n.RapportName.toLowerCase(),
                    CellStyle: { display:"none"},
                },
                {
                    label: <RapportName Value={n.RapportName} onUpdate={(e)=>updateThisName(e.target.value,n.id)}/>,
                    CellStyle: { textAlign: 'left', padding: '2px 5px', borderTop: '4px solid #FFF', borderLeft: '4px solid #FFF', backgroundColor: '#EFEFEF', borderBottom: '4px solid #FFF', fontSize: 14 },
                    width: '150px'
                },
                {
                    label:JSON.parse(n.JsonText).filter(item=>item.Checked === true)
                        .map(item=>{
                            return <Chip color="primary" 
                            size="small" 
                            style={{background:"#0c969c", color:"#fff",borderRadius:"0",margin:"auto 2px"}}
                            label={`${GetMeta(item.Meta)}: ${GetValue(item)}`}
                            />
                        }),
                    CellStyle: { textAlign: 'left', padding: '2px 5px', borderTop: '4px solid #FFF', borderLeft: '4px solid #FFF', backgroundColor: '#EFEFEF', borderBottom: '4px solid #FFF', fontSize: 14 },
                    width: 'auto'
                },
                {
                    label: moment(n.sdate).format("YYYY-MM-DD"),
                    CellStyle: { textAlign: 'left', padding: '2px 5px', borderTop: '4px solid #FFF', borderLeft: '4px solid #FFF', backgroundColor: '#EFEFEF', borderBottom: '4px solid #FFF', fontSize: 14 },
                    width: '100px'
                },
                {
                    label: <Tooltip title="Använd sparat filter" placement="top">
                    <IconButton color="primary" aria-label="getThis" size={"small"} 
                    onClick={()=>props.onSelectSVRapport(n)} component="span">
                        <PublishOutlinedIcon />
                    </IconButton></Tooltip>,
                    CellStyle: { textAlign: 'left', padding: '2px 5px', borderTop: '4px solid #FFF', borderLeft: '4px solid #FFF', backgroundColor: '#EFEFEF', borderBottom: '4px solid #FFF', fontSize: 14 },
                    width: '50px'
                },
                {
                    label: <Tooltip title="Radera sparat filter" placement="top">
                    <IconButton color="secondary" aria-label="getThis" size={"small"} 
                    onClick={()=>onDeleteSVRapport(n)} component="span">
                        <DeleteOutlinedIcon />
                    </IconButton></Tooltip>,
                    CellStyle: { textAlign: 'left', padding: '2px 5px', borderTop: '4px solid #FFF', borderLeft: '4px solid #FFF', backgroundColor: '#EFEFEF', borderBottom: '4px solid #FFF', fontSize: 14 },
                    width: '50px'
                },

            ]
        })
        console.log(data,"DDDASJACK")
        setData(data)
    }
    const GetMeta =(Meta)=>{
        switch(Meta){
            default:return Meta  
        }
    }
    const GetValue =(n)=>{
        switch(n.Meta){
            case "Ansvarig":
                if(parseInt(n.Value) === -1){
                return AllLabel
                }
                else{                    
                    const UserObject = Userlista.filter(item=>{return item.id === parseInt(n.Value)})
                    return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}`    
                }
            case "Ägare":
                if(parseInt(n.Value) === -1){
                return AllLabel
                }
                else{                    
                    const UserObject = Userlista.filter(item=>{return item.id === parseInt(n.Value)})
                    return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}`    
                }
            case "Order ägare":
                if(parseInt(n.Value) === -1){
                return AllLabel
                }
                else{                    
                    const UserObject = Userlista.filter(item=>{return item.id === parseInt(n.Value)})
                    return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}`    
                }
            case "Kundtyp": return getKundType(n.Value)
            case "Taggning":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }else{
                    return n.Value
                }
            case "Leverantör":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }else{
                    return n.Value
                }
            case "Order leverantör":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }else{
                    return n.Value
                }
            case "Prospekt fas":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                    }
                else{
                    const Fas = ProspektFasList.filter(item=>{return parseInt(item.Ordering) === parseInt(n.Value)})
                    return `${Fas[0].FasNamn}`
                }
            case "Fria fält":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                    }
                else{
                    try{
                    const ObjektName = Utokning.filter(item=>{return parseInt(item.id) === parseInt(n.Value)})
                    return `${ObjektName[0].ObjektName}`
                    }
                    catch(error){
                        return ""
                    }
                }
            case "Firmatecknare":return getFirmat(n.Value)
            case "Avtal status":return getAvtalstatus(n.Value)
            case "Order status":return getOrderstatus(n.Value)
            case "Prospekt status":return getProspektstatus(n.Value)
            case "Avtal/Prospekt":return getAvtalprospekt(n.Value)
            case "Avtal skapa datum F.O.M":return n.Value
            case "Avtal skapa datum T.O.M":return n.Value
            case "Avtal omförhandling datum F.O.M":return n.Value
            case "Avtal omförhandling datum T.O.M":return n.Value
            case "Avtal löper ut datum F.O.M":return n.Value
            case "Avtal löper ut datum T.O.M":return n.Value
            case "Prospekt deadline datum F.O.M":return n.Value
            case "Prospekt deadline datum T.O.M":return n.Value
            case "Order skapad datum F.O.M":return n.Value
            case "Order skapad datum T.O.M":return n.Value
            case "Order registrering datum F.O.M":return n.Value
            case "Order registrering datum T.O.M":return n.Value
            case "Betalatdatum F.O.M":return n.Value
            case "Betalatdatum T.O.M":return n.Value
            case "Typ":  
                if(parseInt(n.Value) === -1){
                return AllLabel
            }else{
                return n.Value
            }
            case "Ordertyp":  
                if(parseInt(n.Value) === -1){
                return AllLabel
            }else{
                return n.Value
            }
            default: return `${parseInt(n.Value)===0?YesOption:""}`
        }
    }
    const getKundType=(type)=>{
        switch(parseInt(type)){
            case -1:return AllLabel
            case 0:return <IntlMessages id="Consumer"/>
            case 1:return <IntlMessages id="Enterprise"/>
            case 2:return <IntlMessages id="Branch"/>
            case 3:return <IntlMessages id="Supplier"/>
            case 4:return <IntlMessages id="Resource"/>
        }
    }
    const getFirmat=(Firma)=>{
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case 0:return "Ja"
            case 1:return "Nej"
        }
    }
    const getAvtalstatus=(Firma)=>{
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case 1:return props.intl.formatMessage({ id: 'Active' })
            case 2:return props.intl.formatMessage({ id: 'Completed' })
        }
    }
    const getOrderstatus=(Firma)=>{
        if(parseInt(Firma) === -1){return AllLabel}
        if(isEmpty(props.OrderStatusList)){
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case 2:return "Ny"
            case 3:return "Behandlas"
            case 4:return "Kompletteras"
            case 5:return "Klar"
        }
        }
        else{
            let Sttsta=props.OrderStatusList.filter(item=>{return parseInt(item.Value) === parseInt(Firma) && item.Meta !=="HO.KLAR" && item.Meta !=="HC.KLAR"}) 
            console.log(Sttsta)
            console.log(props.OrderStatusList)
            return Sttsta[0].Meta
        }
    }
    const getProspektstatus=(Firma)=>{
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case 1:return props.intl.formatMessage({ id: 'Active' })
            case 2:return props.intl.formatMessage({ id: 'Label.Lost' })
        }
    }
    const getAvtalprospekt=(Firma)=>{
        switch(parseInt(Firma)){
            case -1:return AllLabel
            case 1:return  <IntlMessages id="File.type.Contract"/>
            case 2:return <IntlMessages id="Prospectus"/>
            case 3:return "Omförhandlad avtal"
            case 4:return "Försäljning"
        }
    }
    const updateThisName=(name,id)=>{
        console.log(name)
        console.log(id)
        dispatch(updateAnpassadName(Afid,userid,id,name))
    }
    const delRapportAn=()=>{
        dispatch(DeleteAnpassadName(Afid,userid,DelItem))
    }
    const onDeleteSVRapport=(row)=>{
        console.log(row)
        setDelItem(row)
    }
    const setthisPage=(page)=>{
        setPage(page)
    }
    const handleSearch = (e) => {
        setsearchWord(e.target.value)
        setPage(1)
      }
    
    return (
        <>
        <NotyfileTableHeader 
          handleSearch={handleSearch}
          searchtext={searchWord}
        />
        <NotyfileTable
        data={
            Data
            .slice((page-1) * 3, (page-1) * 3 + 3)
        }
        columns={columns}
        ScrollX={false}
        page={page}
        pageSize={3}
        totalCount={Data.length}
        RowHiehgt={"40px"}
        setthisPage={setthisPage}
        />
        {
            !isEmpty(DelItem)?
            <DeleteItemPopUp
            onCloseThisPopUp={()=>{setDelItem({})}}
            DelItem={DelItem}
            delRapportAn={delRapportAn}
            />
            :""
        }
        </>
    );
}
export default injectIntl(GetChipsFromSaved);